module.exports = __webpack_public_path__ + "img/9788964960738.ce2bc196.jpg";